import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  positive: {
    color: PALETTE.secondaryActive,
  },
  negative: {
    color: PALETTE.primaryNegative,
  },
  neutral: {
    color: PALETTE.primaryText,
  },
  secondaryActive: {
   color: PALETTE.secondaryActive,
  },
  futureValueDateActive:{
    color: PALETTE.warning,
    fontStyle:'italic'
  },
  negativeStyling:{
    color: 'inherit',
    fontSize:'inherit'
  }
});
